import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface EditorButtonProps {
    onClick?: () => void;
    isActive?: boolean;
    disabled?: boolean;
    tooltip: string;
    children: React.ReactNode;
    className?: string;
}

export const EditorButton = React.forwardRef<HTMLButtonElement, EditorButtonProps>(
    ({ onClick, isActive, disabled, tooltip, children, className, ...props }, ref) => (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    ref={ref}
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={onClick}
                    disabled={disabled}
                    className={cn(isActive && 'bg-accent text-accent-foreground', className)}
                    {...props}
                >
                    {children}
                </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom">
                <p className='text-xs'>{tooltip}</p>
            </TooltipContent>
        </Tooltip>
    )
);

EditorButton.displayName = 'EditorButton';
